export const HOMEPAGE = '/';
export const LOGIN = '/login';
export const RECOMMENDATIONS = '/recommendations';
export const EVENTS = '/events';
export const EVENTFORM = '/events/:eventId/form';
export const DASHBOARD = '/events/:eventId/dashboard';
export const MANAGEMENT = '/management';

export const sharePointLink = 'https://netlight365beta.sharepoint.com/sites/WYLOB2';
